import { Code, Collapse, Group, Paper, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronRight } from '@tabler/icons';
import { useState } from 'react';

interface JsonSectionProps {
  title: string;
  data: Record<string, unknown> | undefined;
  defaultOpened?: boolean;
}

export function JsonSection({ title, data, defaultOpened = false }: JsonSectionProps) {
  const [opened, setOpened] = useState(defaultOpened);
  const isEmpty = !data || Object.keys(data).length === 0;

  return (
    <Paper withBorder>
      <UnstyledButton
        onClick={() => setOpened((current) => !current)}
        px="lg"
        py="sm"
        sx={{ width: '100%' }}
      >
        <Group spacing="xs">
          {opened ? <IconChevronDown size={16} /> : <IconChevronRight size={16} />}
          <Text size="sm" weight={600}>
            {title}
          </Text>
          {isEmpty && (
            <Text size="xs" color="dimmed">
              (empty)
            </Text>
          )}
        </Group>
      </UnstyledButton>
      <Collapse in={opened}>
        <Code block m="lg" mt={0} sx={{ maxHeight: 400, overflow: 'auto' }}>
          {JSON.stringify(data ?? {}, null, 2)}
        </Code>
      </Collapse>
    </Paper>
  );
}
